module.exports = __webpack_public_path__ + "static/media/FF758D70-E5F1-4CEC-9275-8BE41F4DFDC3.d5881be6.jpeg";